module.exports = __webpack_public_path__ + "img/bessac_bg_02_.e48f62f7.jpg";